import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { ExportTrainingsTeamFragment, TrainingWithClassFragment } from 'generated/resources/graphql'

import DayPicker from 'modules/core/components/DayPicker'
import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { useFilters } from 'modules/trainings/hooks/Insights/useFilters'

import TrainingClassFilter from '../TrainingClassFilter'

interface Props {
  trainings: TrainingWithClassFragment[]
  teams: ExportTrainingsTeamFragment[]
}

export const Filters = ({ trainings, teams }: Props) => {
  const filters = useFilters()

  const trainingsData = () => {
    return trainings.map((training) => ({
      label: training.name,
      value: training.id,
      children: training.trainingClasses.map((training_class) => ({
        label: training_class.name,
        value: Number(training_class.id),
      })),
    }))
  }

  return (
    <Box gap="s16" flexDirection="row" alignItems="center" flexWrap="wrap">
      <Box width="s300">
        <DayPicker
          value={filters.dateRange}
          mode="range"
          onChange={(value) => filters.setDateRange(value)}
          placeholder={'from - to'}
        />
      </Box>

      <Box>
        <TrainingClassFilter
          placeholder={i18n.t('trainings.insights.filters.trainings')}
          searchPlaceholder={i18n.t('common.search')}
          data={trainingsData()}
          onChange={(selectedParents, selectedChilds) => {
            filters.setTrainingIds(selectedParents)
            filters.setTrainingClassesIds(selectedChilds)
          }}
        />
      </Box>

      <Box>
        <Selector.Popover
          placeholder={i18n.t('trainings.insights.filters.teams')}
          searchPlaceholder={i18n.t('common.search')}
          blankLabel="no results"
          value={filters.teamIds}
          onChange={(selection) => filters.setTeamIds(selection as number[])}
          isMultiSelect
        >
          {teams.map((team) => (
            <Selector.Option
              key={team.name}
              value={team.id}
              label={team.name}
              searchValue={team.name}
            >
              {team.name}
            </Selector.Option>
          ))}
        </Selector.Popover>
      </Box>
    </Box>
  )
}
